import { STATIC } from './static';

export const SPACING = {
  STATIC,
} as const;

export type SPACING_STATIC_SIZE = (typeof STATIC)[keyof typeof STATIC];
